import React from 'react';
import ClaimType from "../common/ClaimType";

const EmployeeClaimType = () => {
    return (
        <ClaimType headerText="What type of claim are you filing for?"
                   detailsText="We ask this because certain types of claims require different information/documentation."
                   showAdditionalInformation={true}
                   children={<></>}
        />
    )
};
export default EmployeeClaimType;